module.exports = __webpack_public_path__ + "truck-marker.png";